import * as actionTypes from './actionTypes';

import { appInitilizationStarting, applicationInitLoading } from './app';
import {reportListingInitilization,}  from './dashboard'

import { iscAppDataInitilization } from './isc';
import { iamAppDataInitilization } from './asset';
import { ORG_AUTH_URL } from '../../services/TapApiUrls';
import { configurationAppDataInitilization } from './configuration';
import HttpAPICall from '../../services/HttpAPICall';
import TapHelper from '../../services/TapHelper';
import api from '../../services/api';
import { getFireBaseConfig } from '../../services/firebase';


export const authStart = () => {
    return {
        type: actionTypes.AUTH_START
    };
};


export const authRefreshStart = () => {
    return {
        type: actionTypes.AUTH_REFRESH_START
    };
};

export const authRefreshSuccess = () => {
    return {
        type: actionTypes.AUTH_REFRESH_SUCCESS
    };
};

export const authSuccess = (authData) => {

    TapHelper.cookiesSet("access_token",    TapHelper.encrypt(authData.access_token));
    TapHelper.cookiesSet("refresh_token",   TapHelper.encrypt(authData.refresh_token));
    TapHelper.cookiesSet("token_type",      TapHelper.encrypt(authData.token_type));
    TapHelper.cookiesSet("expires_in",      authData.expires_in);


    let data                        =   {
        type                            :   actionTypes.AUTH_SUCCESS,
        access_token                    :   authData.access_token,
        token_type                      :   authData.token_type,
        expires_in                      :   authData.expires_in,
        refresh_token                   :   authData.refresh_token
    }

    //Call Application Initialize Function :-
    return data;
};

export const authFail = (err) => {
    return {
        type: actionTypes.AUTH_FAIL,
        error: err,
        response: err.response,
    };
};

export const logout = (access_token=null) => {

    // Remove access_token, refresh_token, expires_in, token_type, expires_in
    TapHelper.cookiesRemove("access_token");
    TapHelper.cookiesRemove("refresh_token");
    TapHelper.cookiesRemove("token_type");
    TapHelper.cookiesRemove("expires_in");

    if(access_token) {
        HttpAPICall.withAthorization('POST', ORG_AUTH_URL + '/logout', access_token, {}, {})
        .then(function (response) {})
        .catch(function (err) {});
    }

    //Clear All Cookies:-
    TapHelper.clearAllCookies();

    //Clear All Local Storage:-
    localStorage.clear();
    
    return {
        type: actionTypes.AUTH_LOGOUT
    };
};

export const refreshToken = (refresh_token) => {
    return dispatch => {
        if(refresh_token) {
            HttpAPICall.withAthorization('POST', ORG_AUTH_URL + '/login_refresh', null, {}, {refresh_token : refresh_token, device_token : "222"}, (response) => {
                dispatch(authRefreshSuccess());
                dispatch(authSuccess(response.data));
                dispatch(applicationInitLoading(response.data.access_token));
            })
            .then(() =>  { })
            .catch(() =>  {
                dispatch(authRefreshSuccess());
                dispatch(logout());
            })
        }
    };
};

export const authCheckState = () => {
    let access_token    =   TapHelper.decrypt(TapHelper.cookiesGet("access_token"));
    let device_id       =   TapHelper.decrypt(TapHelper.cookiesGet("device_id"));

    console.log("access_token in authCheckState", access_token);
    console.log("device_id in authCheckState", device_id);

    return dispatch => {
       
        //Check Authentication State :-
        if(access_token && device_id) {
            const accessData = {
                access_token            :   access_token,
                refresh_token           :   TapHelper.decrypt(TapHelper.cookiesGet("refresh_token")),
                token_type              :   TapHelper.decrypt(TapHelper.cookiesGet("token_type")),
                expires_in              :   TapHelper.decrypt(TapHelper.cookiesGet("expires_in")),
            };
            dispatch(authSuccess(accessData));
            dispatch(applicationInitLoading(access_token));
            console.log("accessData in authCheckState", accessData);
        } else {
            dispatch(logout());
        }
    };
}

//Firebase Cloud Messaging Token Save :-
export const appFirebaseFCMTokenSaveInit = (access_token=null, firebase_fcm_token=null) => {
    return dispatch => {
        if(access_token && firebase_fcm_token && firebase_fcm_token !== 'blocked') {
            let data = {
                project_id      :   getFireBaseConfig.projectId,
                token           :   firebase_fcm_token
            }
            api.server2Api.post(ORG_AUTH_URL + '/fcm/token', data, { headers: { 'Authorization': 'Bearer ' + access_token } }).then((res) => {}).catch((err) => {});    
        }
    };
};


export const setAuthRedirectPath = (path) => {
    return {
        type: actionTypes.SET_AUTH_REDIRECT_PATH,
        path: path
    };
};

export const clearAppData = () => {
    return dispatch => {
        dispatch(iscAppDataInitilization());
        dispatch(iamAppDataInitilization());
        dispatch(appInitilizationStarting());
        dispatch(reportListingInitilization());
        dispatch(configurationAppDataInitilization())
    };
}